import { Component } from '@angular/core';
import { VenturesComponent } from '@src/app/components/ventures/ventures.component';
import { GlobalEventBus } from '@src/app/shared/enums/event-bus.enum';

@Component({
  selector: 'app-venture-tiles-cbcharta',
  templateUrl: './venture-tiles-cbcharta.component.html',
})
export class VentureTilesCbchartaComponent extends VenturesComponent {
  protected listenFilterPaneEvent(): void {
    this.globalPaneEvent = this.eventBus.addEventListener({
      name: GlobalEventBus.FilterPaneEvent,
      callback: () => {
        this.entityGlobalFilterCriteria['sortingAttribute'] =
          this.sortingPayload['sortingAttribute'];

        this.filterData();
      },
    });
  }
}
